import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Iter 45p — Local-date discipline. NEVER use toISOString().slice(0,10)
// to derive a service date; that returns UTC and shifts day by 1 in
// any non-UTC timezone after sundown (PT/MT/CT/ET all have this issue).
// Use this helper everywhere a "today" date string is needed for a
// service record (sessions, trial runs, goal evidence).
export function localDateStr(d) {
  const dt = d instanceof Date ? d : new Date();
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
}
